import { render, staticRenderFns } from "./BlockHighlight.vue?vue&type=template&id=51026b30&"
import script from "./BlockHighlight.vue?vue&type=script&lang=js&"
export * from "./BlockHighlight.vue?vue&type=script&lang=js&"
import style0 from "./BlockHighlight.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports